import { DbEnum } from "../../../../generated/prisma-enums";
import { INTEGRATION_DISPLAY_NAMES } from "../../agents/agent-prompt.constants";

/**
 * The deployment types the `deployments.create` action can actually create, in
 * the order the node editor lists them.
 *
 * **This tuple IS the contract.** The catalog's `allowedValues` and
 * `allowedOptions` are derived from it, so the dropdown cannot offer a type the
 * executor refuses. It did: it offered `WIDGET`, `EMAIL` and `PHONE`, none of
 * which is a `DeploymentType`, beside `WHATSAPP`, which needs a phone number this
 * action has no input for.
 *
 * The action creates through `CreateDeploymentUseCase` with empty settings and
 * no phone number or connection, so a type belongs here exactly when that use
 * case accepts it from that input: its write schema admits `{}`, it needs no
 * OAuth connection, and it is not bound to a phone number. Every other type —
 * EMBED, TELEGRAM, TWILIO_VOICE and the rest — needs settings or a binding only
 * the console collects.
 *
 * 🔴 NOTHING IN THIS PACKAGE CAN CHECK THAT, because the rule lives in the
 * backend's validator. `nexus-api-node.creatable-deployment-types.spec.ts` runs
 * the real validator over EVERY `DeploymentType` and requires this tuple to be
 * exactly the set it accepts, in both directions — so a schema change that makes
 * a type creatable or not reds there until this list follows it.
 */
export const WORKFLOW_CREATABLE_DEPLOYMENT_TYPES = [
  DbEnum.DeploymentType.SLACK,
  DbEnum.DeploymentType.API,
  DbEnum.DeploymentType.FB_MESSENGER,
  DbEnum.DeploymentType.INSTAGRAM,
  DbEnum.DeploymentType.IMAP,
  DbEnum.DeploymentType.SMTP,
  DbEnum.DeploymentType.EXCEL_ADDIN,
  DbEnum.DeploymentType.WORD_ADDIN,
  DbEnum.DeploymentType.POWERPOINT_ADDIN,
  DbEnum.DeploymentType.AIRTABLE,
  DbEnum.DeploymentType.GOOGLE_MEET,
  DbEnum.DeploymentType.ZOOM
] as const;

/** The dropdown's entries, labelled by the one display-name table. */
export const WORKFLOW_CREATABLE_DEPLOYMENT_TYPE_OPTIONS = WORKFLOW_CREATABLE_DEPLOYMENT_TYPES.map(
  (type) => ({ label: INTEGRATION_DISPLAY_NAMES[type], value: type })
);
